module.exports = __webpack_public_path__ + "vue/img/bad-portrait-photo2.e0854147.jpg";